import * as React from 'react';
import { SVGProps } from 'react';

const IconVolumeUpSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="m5.944 8 4.16-3.663c.7-.72 1.896-.21 1.896.808v13.71c0 1.018-1.197 1.528-1.897.808L6 16H3a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h2.944ZM18.111 4.898a1 1 0 0 1 1.407.142 11 11 0 0 1-.01 13.933 1 1 0 0 1-1.547-1.268 9 9 0 0 0 .008-11.4 1 1 0 0 1 .142-1.407Z" />
    <path d="M14.513 7.425a1 1 0 0 1 1.408.142 7 7 0 0 1-.007 8.866 1 1 0 0 1-1.547-1.268 5 5 0 0 0 .005-6.333 1 1 0 0 1 .141-1.407Z" />
  </svg>
);
export default IconVolumeUpSizeM;
